import { validationErrors } from "../utils";
import ajaxService from "./ajax-service";

class VendorService {
  async fetch(page, pageSize, search) {
    const pageParam = `page=${page}&perPage=${pageSize}`
    let params = search ? `search=${search}` : pageParam;

    const response = await ajaxService.get(`/vendors?${params}`);
    if (response ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async fetchAll() {
    const response = await ajaxService.get(`/vendors?all=true`);
    if (response ?? false) {
      return response;
    }
  }
  async fetchCategories() {
    const response = await ajaxService.get(`/vendors-categories`);
    if (response ?? false) {
      return response;
    }
  }
  async viewVendor(id) {
    const response = await ajaxService.get(`/vendors/${id}`);
    if (response ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async addVendor(data) {
    const response = await ajaxService.post(`/vendors`, data);
    if (response.success ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async updateVendor(id, data) {
    const response = await ajaxService.put(`/vendors/`, id, data);
    if (response?.success ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async deleteVendor(id) {
    const response = await ajaxService.delete(`/vendors/`, id);
    if (response ?? false) {
      return response;
    }
  }
}

const vendorService = new VendorService();
export default vendorService;
